import { HTTP_STATUS } from '@/shared/lib'

import type { ApiErrorLike } from './apiErrorLike'

import { type ActualizeCartError, ACTUALIZE_CART_ERROR } from '../model'
import { ACTUALIZE_CART_API_DETAIL, ACTUALIZE_CART_VALIDATION_LOC } from './actualizeCartApiErrorDetail'

const getDetailString = (error: unknown): string | null => {
  const detail = (error as ApiErrorLike)?.detail

  if (typeof detail === 'string') {
    return detail
  }

  return null
}

const resolveValidationError = (detail: ApiErrorLike['detail']): ActualizeCartError | null => {
  if (!Array.isArray(detail)) {
    return null
  }

  const hasInvalidProductId = detail.some((item) => item.loc.includes(ACTUALIZE_CART_VALIDATION_LOC.productId))
  if (hasInvalidProductId) {
    return ACTUALIZE_CART_ERROR.invalidProductId
  }

  return null
}

export const resolveActualizeCartError = (error: unknown, status?: number): ActualizeCartError => {
  if (status === HTTP_STATUS.unauthorized) {
    return ACTUALIZE_CART_ERROR.unauthorized
  }

  if (status === HTTP_STATUS.forbidden) {
    return ACTUALIZE_CART_ERROR.forbidden
  }

  if (status === HTTP_STATUS.notFound || getDetailString(error) === ACTUALIZE_CART_API_DETAIL.notFound) {
    return ACTUALIZE_CART_ERROR.productNotFound
  }

  if (status === HTTP_STATUS.unprocessableEntity) {
    const validationError = resolveValidationError((error as ApiErrorLike)?.detail)
    if (validationError) {
      return validationError
    }
  }

  return ACTUALIZE_CART_ERROR.generic
}
